import { BillingType } from './pricing.types.js';
import { getPlans, getExtensiveLifetimePlan } from './pricing.config.js';
import { SubscriptionTier } from '@fabric/woody-client';
import { BillingPeriod } from '@fabric-app/types/pricing/pricing.types';

const isPlanBelow = (planTier1, planTier2) => {
  const plans = getPlans();
  const plan1 = plans[planTier1];
  const plan2 = plans[planTier2];
  return plan1.order < plan2.order;
};
const billingPeriodOrder = {
  [BillingPeriod.Monthly]: 1e3,
  [BillingPeriod.Yearly]: 2e3,
  [BillingPeriod.ThreeYears]: 3e3
};
const isPlanBelowInclBillingPeriod = (p1, p2) => {
  if (p1.tier === p2.tier) {
    if (!p1.billingPeriod || !p2.billingPeriod) {
      return false;
    }
    return billingPeriodOrder[p1.billingPeriod] < billingPeriodOrder[p2.billingPeriod];
  }
  const plans = getPlans();
  const plan1 = plans[p1.tier];
  const plan2 = plans[p2.tier];
  return plan1.order < plan2.order;
};
const isPaidTier = (tier) => {
  const plans = getPlans();
  const plan = plans[tier];
  return plan.prices.billedMonthly > 0;
};
const isSubscribedPlan = (plan) => {
  return !(plan ?? "free").startsWith("free");
};
const getFullTierFromUser = (user) => {
  if (!user.subscription.tier) return SubscriptionTier.FREE;
  if (user.subscription.tier === SubscriptionTier.LIFETIME || user.subscription.tier === SubscriptionTier.FREE) {
    return user.subscription.tier;
  }
  return `${user.subscription.tier}-${user.subscription.billingCycle}`;
};
const getCurrentStripePlanId = (prices, billingPeriod) => {
  switch (prices.type) {
    case BillingType.Recurring:
      return billingPeriod === BillingPeriod.Monthly ? prices.stripePlanIdMonthly : prices.stripePlanIdYearly;
  }
};
const getFullTierFromPlan = ({ tier, prices }, billingPeriod) => {
  const planId = getCurrentStripePlanId(prices, billingPeriod);
  if (!planId) return "free";
  if (tier === SubscriptionTier.LIFETIME || tier === SubscriptionTier.FREE) return tier;
  return `${tier}-${billingPeriod}`;
};
const getPlanByTier = (tier, extensive = false) => {
  const plans = getPlans();
  if (tier === SubscriptionTier.LIFETIME) {
    return extensive ? getExtensiveLifetimePlan() : plans[SubscriptionTier.LIFETIME];
  }
  return plans[tier];
};
const getPlanByOfferingId = (offeringId) => {
  return Object.values(getPlans()).filter((p) => p.purchaseable).find((plan) => plan.prices.revenueCatOfferingId === offeringId);
};
const getPlanWithUpgradedEntitlement = (currentPlan, entitlement) => {
  const plans = getPlans();
  const currentEntitlementValue = currentPlan.entitlements[entitlement];
  const nextPlan = Object.values(plans).find((plan) => {
    if (!plan.purchaseable) {
      return;
    }
    const nextFeatureValue = plan.entitlements[entitlement];
    if (typeof nextFeatureValue === "number" && typeof currentEntitlementValue === "number") {
      return nextFeatureValue > currentEntitlementValue;
    }
    return nextFeatureValue;
  });
  return nextPlan || null;
};

export { getCurrentStripePlanId, getFullTierFromPlan, getFullTierFromUser, getPlanByOfferingId, getPlanByTier, getPlanWithUpgradedEntitlement, isPaidTier, isPlanBelow, isPlanBelowInclBillingPeriod, isSubscribedPlan };
//# sourceMappingURL=pricing.utils.js.map
